import { reducerWithInitialState } from 'typescript-fsa-reducers/dist';
import { setSkillBarName } from '../actions/skill-bar';

export interface SkillBarState {
  skillName: string;
}

const INITIAL_STATE: SkillBarState = {
  skillName: ''
};

function setSkillBarNameReducer(
  state: SkillBarState,
  skillName: string
): SkillBarState {
  return { ...state, skillName };
}

export const skillBarReducer = reducerWithInitialState(INITIAL_STATE)
  .case(setSkillBarName, setSkillBarNameReducer)
  .build();
